import { ASSETS_LOCATIONS, getAssetsUrl } from '../../../utilities/constants';

export const OFFERS_IMAGES = {
  OFFERS_GWL_VOYAGERS_CLUB: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'gwl-voyagers-club.svg'),
  OFFERS_V_GREEN_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-green.svg'),
  OFFERS_V_BLUE_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-blue.svg'),
  OFFERS_V_GRAY_ICON: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-gray.svg')
};
